import { Pipe, PipeTransform } from '@angular/core';
import { Widget } from '../../../../viewmodels/dashboard/widget';
import { WidgetDataType } from '../widget-data-type';

@Pipe({
  name: 'widgetSubtitleTooltip',
})
export class WidgetSubtitleTooltipPipe implements PipeTransform {
  transform(value: Widget): string {
    if (!value) {
      return '';
    }

    switch (value.widgetDataType) {
    case WidgetDataType.MitigationsDueByMonth:
      return 'Displayed Date Range.';
    }

    return '';
  }
}
